<template>
    <div v-if="stage" class="px-4">
        <v-row>
            <v-col cols="6">
                <v-card-text class="ml-0 pa-0 ma-0">
                    <label> Endpoint URL: </label>
                </v-card-text>
                <RouteInBagSelectorComponent
                    v-model="stage.endpoint"
                    :my_bag="my_bag"
                    outlined
                    hide-details="auto"
                    :error="showErrors && !stage.endpoint"
                    @change="computeStage">
                </RouteInBagSelectorComponent>
            </v-col>
            <v-col cols="6">
                <v-card-text class="ml-0 pa-0 ma-0">
                    <label> Método de solicitud: </label>
                </v-card-text>
                <v-select
                    v-model="stage.request_method"
                    :items="request_method_options"
                    item-text="name"
                    item-value="name"
                    @change="handleMethodChange"
                >
                </v-select>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="6">
                <v-card-text class="ml-0 pa-0 ma-0">
                    <label> Payload: </label>
                </v-card-text>
                <RouteInBagSelectorComponent
                    v-model="stage.payload_location"
                    :my_bag="my_bag"
                    outlined
                    hide-details="auto"
                    @change="computeStage">
                </RouteInBagSelectorComponent>
            </v-col>
            <v-col cols="6">
                <v-card-text class="ml-0 pa-0 ma-0">
                    <label> Headers: </label>
                </v-card-text>
                <RouteInBagSelectorComponent
                    v-model="stage.headers_location"
                    :my_bag="my_bag"
                    outlined
                    hide-details="auto"
                    @change="computeStage">
                </RouteInBagSelectorComponent>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="6">
                <v-card-text class="ml-0 pa-0 ma-0">
                    <label> Files: </label>
                </v-card-text>
                <RouteInBagSelectorComponent
                    v-model="stage.files_location"
                    :my_bag="my_bag"
                    outlined
                    hide-details="auto"
                    @change="computeStage">
                </RouteInBagSelectorComponent>
            </v-col>
        </v-row>
        <v-row>
            <h3> Guardado respuesta </h3>
        </v-row>
        <v-row>
            <v-col cols="6">
                <v-col>
                    <v-select
                    v-model="stage.entity_type_id"
                    :items="available_types"
                    label="Tipo de salida"
                    item-text="name" 
                    item-value="uuid"
                    outlined
                    hide-details="auto">
                    </v-select>
                </v-col>
            </v-col>
            <v-col cols="6">
                <v-text-field
                    v-model="stage.save_as_key"
                    label="Clave de guardado"
                    outlined
                    hide-details="auto"
                    @change="computeStage">
                </v-text-field>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { SendDataToEndpoint } from '@/modules/document/domain/WorkflowTemplate';
import RouteInBagSelectorComponent from '@/modules/document/infra/RouteInBagSelectorComponent';
export default {
    name:'SendDataToEndpointDetailComponent',
    components: {
        RouteInBagSelectorComponent
    },
    props:{
        stage: {
            type: SendDataToEndpoint,
            default: false,
        },
        showErrors: {
            type: Boolean,
            default: false
        },
        available_types: {
            type: Array,
            default: () => []
        },
        my_bag: {
            type: Object,
            default: () => {}
        }
    },
    data(){
        return {
            show_custom_prompt: false,
            request_method_options: [ 
                        {name: "GET"}, 
                        {name: "POST"}
                    ],
        }
    },
    mounted(){
        console.log(this.stage);
    },
    methods:{
        computeStage(){
            this.$emit('compute-stage');
        },
        handleMethodChange(){
            console.log("metodo seleccionado: ", this.method_selected)
        }
    },
    computed:{
        
    },
}
</script>

<style scoped >
/*@import url('https://unpkg.com/json-schema-editor-vue@2.3.0/lib/json-schema-editor-vue.css');*/
.preaty__card {
    border-radius: 5px;
}
.small_scrollbar >>> textarea {
    scrollbar-width: thin;
}
.error--text {
    color: rgba(220, 11, 11, 0.898) !important;
}
</style>